import { Component, Input } from '@angular/core';
import {
	Capability,
	ConnectionSource
} from '@brand-lolly/app/_models/brand-instagram-integration.model';
import { LoStatus } from 'lo-design-system';

interface Cell {
	key: Capability;
	label: string;
	hint?: string;
	granted: boolean;
}

const CAPABILITY_ORDER: Array<{ key: Capability; label: string }> = [
	{ key: 'dm', label: 'DM' },
	{ key: 'ads', label: 'Ads' },
	{ key: 'insights', label: 'Insights' },
	{ key: 'publish', label: 'Publish' },
	{ key: 'mentions', label: 'Mentions' },
	{ key: 'creator_marketplace', label: 'Marketplace' },
	{ key: 'social_listening', label: 'Social listening' }
];

@Component({
	standalone: true,
	selector: 'meta-ig-capabilities-grid',
	imports: [LoStatus],
	template: `
		<div class="grid">
			@for (cell of cells; track cell.key) {
			<div class="cell">
				<lo-status dot [tone]="cell.granted ? 'success' : 'neutral'">
					{{ cell.label }}
				</lo-status>
				@if (cell.hint) {
				<span class="hint lo-type-text-xs">{{ cell.hint }}</span>
				}
			</div>
			}
		</div>
	`,
	styles: [
		`
			:host {
				display: block;

				.grid {
					display: grid;
					grid-template-columns: 1fr 1fr;
					gap: var(--lo-space-gap-md) var(--lo-space-gap-lg);

					.cell {
						display: flex;
						align-items: center;
						gap: var(--lo-space-gap-sm);
						min-width: 0;

						.hint {
							color: var(--lo-color-text-secondary);
						}
					}
				}
			}
		`
	]
})
export class MetaIgCapabilitiesGridComponent {
	@Input() supports: Capability[] = [];
	@Input() connectionSources: ConnectionSource[] = [];

	get cells(): Cell[] {
		return CAPABILITY_ORDER.map(({ key, label }) => {
			const granted = this.supports.includes(key);
			let hint: string | undefined;
			if (key === 'dm' && !granted) {
				hint = this.connectionSources.includes('password')
					? undefined
					: 'needs password';
			}
			return { key, label, hint, granted };
		});
	}
}
